import { createEvent } from 'effector';
import { Language } from 'models';

export const changeLanguage = createEvent<Language>();
